<template>
  <div v-if="show" class="graph-stats">
    <div class="graph-header">
      <h4>{{ title }}</h4>
    </div>
    <div class="-wrapper">
      <highcharts ref="chart" :options="chartOptions"></highcharts>
    </div>
  </div>
</template>
<script>
export default {
  props: ["statsData", "mobile", "title"],
  computed: {
    show() {
      return (
        this.statsData &&
        this.statsData.categories &&
        this.statsData.categories.length > 0 &&
        this.statsData.series &&
        this.statsData.series.length &&
        this.statsData.series[0].data &&
        this.statsData.series[0].data.length
      );
      // lol
    }
  },
  watch: {
    statsData: {
      deep: true,
      handler() {
        this.chartOptions.xAxis.categories = this.statsData.categories;
        this.chartOptions.series = this.statsData.series;
        this.chartOptions.xAxis.max = this.statsData.categories.length - 1.48;
      }
    }
  },
  data() {
    return {
      chartOptions: {
        showInLegend: false,
        chart: {
          type: "area",
          renderTo: "container",
          height: this.mobile ? 150 : 250,
          plotAreaWidth: 300,
          plotAreaHeight: 200
        },
        labels: {
          enabled: false
        },
        title: {
          text: null
        },
        subtitle: {
          text: ""
        },
        margin: 0,
        xAxis: {
          lineWidth: 0,
          gridLineWidth: 0,
          minorGridLineWidth: 0,
          minPadding: 0,
          maxPadding: 0,
          tickWidth: 0,
          minRange: 0.001,
          tickmarkPlacement: "on",
          min: 0,
          max: this.statsData.categories.length - 1.48 || 1,
          startOnTick: false,
          endOnTick: false,
          align: "left",
          labels: {
            enabled: true
          },
          title: {
            enabled: false
          },
          categories: []
        },
        yAxis: {
          gridLineColor: "transparent",
          labels: {
            format: "{value}"
          },
          title: {
            enabled: false
          }
        },

        legend: {
          enabled: false
        },
        plotOptions: {
          series: {
            pointPadding: 0,
            groupPadding: 0
          },
          column: {
            pointPadding: 0,
            borderWidth: 0,
            groupPadding: 0,
            shadow: false,
            stacking: "percent"
          }
        },

        series: []
      }
    };
  }
};
</script>
